module.exports = __webpack_public_path__ + "static/img/icon_hitem3.9b2821a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_hitem3.png
// module id = X1km
// module chunks = 21